import classes from "./ActivityEditor.module.css";
import {
    QUESTION_MAX_POINTS,
} from "../../utils/constants";
import {
    getQuestionCorrectnessPoints,
    getQuestionParticipationPoints
} from "../../utils/helpers";
import React, { useState} from "react";
import {ReactComponent as CORRECTNESS_ICON} from "./images/CorrectnessBadge.svg";
import {ReactComponent as PARTICIPATION_ICON} from "./images/ParticipationBadge.svg";
import DropdownWeightage from "../../components/DropdownWeightage";
import {updateParticipationWeightage, updateWeightage} from "../../utils/questionUpdate";
import {ReactComponent as WEIGHTAGE_ICON} from "../../images/weightage_purple.svg"
import { ReactComponent as ArrowDown } from "./images/CaretDown.svg";
import { ReactComponent as ArrowUp } from "./images/CaretUp.svg";
import { ReactComponent as INFO } from "./images/info.svg";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import { Popover } from '@base-ui/react/popover';
import { Separator } from '@base-ui/react/separator';
import { useTranslation } from "react-i18next";

export default function QuestionWeightageButton({draftActivity, setDraftActivity, currQueDisplay}) {
    const { t } = useTranslation();
    const {questions=[]} = draftActivity;
    const selectedQuestion = !!questions[currQueDisplay - 1] ? questions[currQueDisplay - 1] : {};
    const {weightage=0, participationWeightage=0} = selectedQuestion;

    const [isOpened, setIsOpened] = useState(false);


    return (
        <Popover.Root
            open={isOpened}
            onOpenChange={(open) => setIsOpened(open)}
        >
            <Popover.Trigger
                // id={`activity-share-button-${randomId}`}
                delay={0}
                aria-label={t("questionBank.editPointsTitle")}
                className={`${classes.weightageBtn} ${isOpened ? classes.opened : ""}`}
                style={{gap: 7}}
            >
                <div className={classes.weightageIcon}>
                    <WEIGHTAGE_ICON/>
                </div>
                {(weightage + participationWeightage) === 0
                    ? t("poll.ungradedText")
                    : `${weightage + participationWeightage} ${t("poll.pointsText")}`
                }
                {!isOpened && <ArrowDown/>}
                {isOpened && <ArrowUp/>}
            </Popover.Trigger>

            <Popover.Portal keepMounted={true}>
                <Popover.Positioner
                    sideOffset={5}
                    align={"end"}
                    style={{zIndex: 1}}
                >
                    <Popover.Popup
                        aria-modal="false"
                        initialFocus={false}
                        className={classes.weightageEditCard}
                        style={{
                            color: "#000",
                            overflow: "auto",
                        }}
                    >
                        <div className={classes.column} style={{width: 160, gap: 12}}>
                            <div className={classes.row} style={{gap: 8}}>
                                <CORRECTNESS_ICON/>
                                <span>{t("questionBuilder.correctnessLabel")}</span>
                                <YuJaTooltip text={t("questionBuilder.pointMenuCorrectnessDescription")}
                                             tooltipStyle={{maxWidth: 300}}>
                                    <INFO name={"info"} style={{width: 20, height: 20}}/>
                                </YuJaTooltip>
                            </div>
                            <DropdownWeightage
                                defaultWidth={150}
                                showIcon={false}
                                weightage={getQuestionCorrectnessPoints(selectedQuestion)}
                                setWeightage={(v) => {
                                    if (!v) {
                                        v = 0;
                                    } else {
                                        v = parseInt(v);
                                    }
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.questions = updateWeightage(v, currQueDisplay - 1, copy.questions);

                                    setDraftActivity(copy);
                                }}
                                maxVal={QUESTION_MAX_POINTS - getQuestionParticipationPoints(selectedQuestion)}
                                dropdownStyle={{border: "1px solid #E5E7EB", borderRadius: 10}}
                                upIcon={ArrowUp}
                                downIcon={ArrowDown}
                            />
                        </div>

                        <Separator orientation={"vertical"} style={{height: 90, width: 1, background: "#E5E7EB", margin: "0 20px"}}/>

                        <div className={classes.column} style={{width: 160, gap: 12}}>
                            <div className={classes.row} style={{gap: 8}}>
                                <PARTICIPATION_ICON/>
                                <span>{t("questionBuilder.participationLabel")}</span>
                                <YuJaTooltip text={t("questionBuilder.pointMenuParticipationDescription")}
                                             tooltipStyle={{maxWidth: 300}}>
                                    <INFO name={"info"} style={{width: 20, height: 20}}/>
                                </YuJaTooltip>
                            </div>
                            <DropdownWeightage
                                defaultWidth={150}
                                showIcon={false}
                                weightage={getQuestionParticipationPoints(selectedQuestion)}
                                setWeightage={(v) => {
                                    if (!v) {
                                        v = 0;
                                    } else {
                                        v = parseInt(v);
                                    }
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    copy.questions = updateParticipationWeightage(v, currQueDisplay - 1, copy.questions);
                                    setDraftActivity(copy);
                                }}
                                maxVal={QUESTION_MAX_POINTS - getQuestionCorrectnessPoints(selectedQuestion)}
                                dropdownStyle={{border: "1px solid #E5E7EB", borderRadius: 10}}
                                upIcon={ArrowUp}
                                downIcon={ArrowDown}
                            />
                        </div>
                    </Popover.Popup>
                </Popover.Positioner>
            </Popover.Portal>
        </Popover.Root>
    );
}